import { Box, Grid, Link, Typography } from "@mui/material";

function Footer() {
    return <Box component="footer">
        <Grid
            container
            rowSpacing={1}
            columnSpacing={2}
            justifyContent="center"
            sx={{ paddingTop: 2, paddingBottom: 6 }}
        >
            <Grid item>
                <Typography variant="body2">
                    📧Mail me:{" "}
                    <Link href="mailto:simworldcup@gmail.com">
                        simworldcup@gmail.com
                    </Link>
                </Typography>
            </Grid>
            <Grid item>
                <Typography variant="body2">
                    ☕Support me:{" "}
                    <Link
                        href="https://ko-fi.com/simworldcup"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://ko-fi.com/simworldcup
                    </Link>
                </Typography>
            </Grid>
        </Grid>
    </Box>;
}

export default Footer